import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import getSectionSubsections from '../Sitemap/Helpers/getSectionSubsections';
import Submenu from '../Submenu/Submenu';

interface EducationViewProps extends RouteComponentProps<{}> { }

export default function EducationalView(props: EducationViewProps) {

    const { match } = props

    const subsections = getSectionSubsections(3)
    const subsection = subsections.find(subsection => subsection.route === match.path)
    const component = subsection ? subsection.component : null

    return (
        <>
            <Submenu items={subsections} path={match.path} />
            {component}
        </>
    )
}
